import { notificacaoErro } from "../app/notificacao";

async function fetchCriaMotivo(body, token) {
  const url = new URL(process.env.REACT_APP_API_URL + "/motivos");
  const init = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(body),
  };

  const fet = await fetch(url, init);

  switch (fet.status) {
    case 201:
      return { success: true, status: fet.status, data: await fet.json() };
    case 404:
      return {
        success: false,
        status: fet.status,
        error: notificacaoErro(fet, init, "Ocorreu um erro ao criar motivo."),
      };
    default:
      return {
        success: false,
        status: fet.status,
        error: notificacaoErro(fet, init, "Ocorreu um erro inesperado ao criar motivo."),
      };
  }
}

const criaMotivo = { fetchCriaMotivo };

export default criaMotivo;
